import { Panel } from '@efira/ui';

import type { Zone } from './zones';

/**
 * Пустая зона.
 *
 * Текст объясняет УСЛОВИЕ появления данных, а не констатирует пустоту
 * (docs/SPEC.md, 2.3): «Пусто» читается как поломка, «здесь появится X, когда
 * вы сделаете Y» - как инструкция.
 */
export function EmptyZone({ zone }: { zone: Zone }) {
  return (
    <Panel title={zone.emptyTitle}>
      <p className="text-foreground/80 text-sm">{zone.emptyText}</p>
    </Panel>
  );
}
